import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import config from './config';
import './filters';
import './auth';

import Index from './Index';
import router from './router';
import store from './store';

import './directives/FallbackSrc';

const SentryBrowser = () => import(/* webpackChunkName: "Sentry" */ '@sentry/browser');
const SentryIntegrations = () => import(/* webpackChunkName: "Sentry" */ '@sentry/integrations');

(async () => {
  if (config.features.sentryMonitoring) {
    const Sentry = await SentryBrowser();
    const Integrations = await SentryIntegrations();

    Sentry.init({
      dsn: config.sentryDsn,
      integrations: [new Integrations.Vue({ Vue })],
    });
  }

  Vue.config.productionTip = false;

  await store.dispatch('fetchBrand');

  Vue.use(Vuetify);
  const opts = {
    theme: { themes: { light: store.getters.brand.theme } },
  };

  // eslint-disable-next-line no-new
  const main = new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(Index),
    vuetify: new Vuetify(opts),
  });

  store.watch(
    (state, getters) => getters.brand.theme,
    (theme) => {
      main.$vuetify.theme = theme;
    }
  );
})();
